import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  accent: { color: colors.gilead.primary1 },
  transparentButton: { backgroundColor: 'transparent' },
  root: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }),
    },
  },
  title: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3.75),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3.75),
      }),
    },
  },
  text: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: '0.1px',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      paddingLeft: 33,
      fontSize: 14,
      lineHeight: '20px',
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        paddingLeft: 33,
        fontSize: 14,
        lineHeight: '20px',
      }),
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(9),
    '& button': {
      width: 138,
    },
    '& button:nth-child(1)': {
      color: theme.palette.primary1,
    },
    [theme.breakpoints.down('lg')]: {
      '& button:nth-child(2)': {
        width: 200,
      },
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'end',
      flex: 1,
      '& button': {
        height: 44,
      },
      '& button:nth-child(1)': {
        paddingLeft: 0,
        width: 92,
      },
      '& button:nth-child(2)': {
        width: 204,
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        '& button:nth-child(2)': {
          width: 200,
        },
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        alignItems: 'end',
        flex: 1,
        '& button': {
          height: 44,
        },
        '& button:nth-child(1)': {
          paddingLeft: 0,
          width: 92,
        },
        '& button:nth-child(2)': {
          width: 204,
        },
      }),
    },
  },
  radioGroup: {
    width: '75%',
  },
  formControlLabel: {
    color: theme.palette.text.secondary,
    '& .MuiFormControlLabel-label': {
      fontSize: 18,
    },
    '& .MuiRadio-root': {
      paddingTop: 0,
      paddingBottom: 0,
      alignSelf: 'baseline',
      '&:not(.Mui-checked)': { color: theme.palette.grey1 },
    },
    '&:nth-child(even):not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiFormControlLabel-label': {
        fontSize: 16,
      },
      '& > span:nth-child(1)': {
        position: 'relative',
        bottom: 30,
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        '& .MuiFormControlLabel-label': {
          fontSize: 16,
        },
        '& > span:nth-child(1)': {
          position: 'relative',
          bottom: 30,
        },
      }),
    },
  },
}));
